module.exports = __webpack_public_path__ + "img/Name.fdcf8df0.svg";